import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
// workaround when parent use modal component
// https://github.com/DucktorDanny/react-beautiful-dnd-example
export const useDraggableInPortal = () => {
    const element = useRef(document.createElement('div')).current;
    useEffect(() => {
        if (element) {
            element.style.pointerEvents = 'none';
            element.style.position = 'absolute';
            element.style.height = '100%';
            element.style.width = '100%';
            element.style.top = '0';
            element.style.zIndex = '15000';
            document.body.appendChild(element);
            return () => {
                document.body.removeChild(element);
            };
        }
        return undefined;
    }, [element]);
    return (render) => (provided, snapshot) => {
        const result = render(provided, snapshot);
        const style = provided.draggableProps.style;
        if (style.position === 'fixed') {
            return createPortal(result, element);
        }
        return result;
    };
};
//# sourceMappingURL=useDraggableInPortal.js.map